import type { FormArray } from '@angular/forms';

import { isNil } from '@pct-ts/typeguard';
import type { TypedValidatorFn } from './typed-validator-fn';

export interface IFormArrayMaxLengthError {
  formArrayMaxLength: { maxLength: number; actualLength: number };
}

export function formArrayMaxLength(maxLength: number): TypedValidatorFn<IFormArrayMaxLengthError> {
  // @ts-expect-error AbstractControl needed from ValidatorFn but FormArray is valid
  return (array: FormArray): IFormArrayMaxLengthError | null => {
    if (!isNil(array) && array.length > maxLength) {
      return {
        formArrayMaxLength: { maxLength, actualLength: array.length },
      };
    }
    return null;
  };
}
